import React, { useState } from 'react';
import TestHeader from '../previous-paper/TestHeader';
import ReadingPassage from './ReadingPassage';
import QuestionArea from './QuestionArea';
import QuestionPalette from './QuestionPalette';

const TestInterface = () => {
    const [currentQIndex, setCurrentQIndex] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const tabs = [
        { label: "QA (1–25)", title: "Quantitative Aptitude", start: 0, end: 25 },
        { label: "English (26–50)", title: "English", start: 25, end: 50 },
        { label: "Reasoning (51–75)", title: "Reasoning", start: 50, end: 75 },
        { label: "GA (76–100)", title: "General Awareness", start: 75, end: 100 },
    ];

    const [questions, setQuestions] = useState(
        Array.from({ length: 25 }, (_, i) => ({
            id: i + 1,
            text: `Question ${i + 1}: This is a sample question for question number ${i+1}. What is the correct answer?`,
            options: [ { id: "A", text: "Option A" }, { id: "B", text: "Option B" }, { id: "C", text: "Option C" }, { id: "D", text: "Option D" } ],
            selectedOption: null,
            status: "not_visited"
        }))
    );

    const currentQ = questions[currentQIndex];

    const handleOptionSelect = (optId) => {
        const updated = [...questions];
        updated[currentQIndex].selectedOption = optId;
        setQuestions(updated);
    };

    // const handleNext = () => {
    //     const updated = [...questions];
    //     if (currentQ.selectedOption) updated[currentQIndex].status = "answered";
    //     else if (currentQ.status === "not_visited") updated[currentQIndex].status = "not_answered";
    //     setQuestions(updated);
    //     if (currentQIndex < questions.length - 1) setCurrentQIndex(currentQIndex + 1);
    // };

    return (
        <div className="min-h-screen bg-[#F8F9FA] flex flex-col font-sans">
            <TestHeader />
            
            <main className="max-w-[1440px] mx-auto w-full px-4 py-6 flex flex-col lg:flex-row gap-4">
                {/* LEFT SIDE: THEORETICAL */}
                <ReadingPassage />

                {/* CENTER SIDE: QUESTION AREA */}
                <div className="flex-1 border-gray-200 p-4 flex flex-col justify-between">
                    <QuestionArea currentQ={currentQ} handleOptionSelect={handleOptionSelect} />
                    
                    {/* Action Bar */}
                    {/* <div className="flex flex-wrap items-center justify-between gap-4 pt-8 border-t border-gray-100 mt-10">
                        <button onClick={() => currentQIndex > 0 && setCurrentQIndex(currentQIndex - 1)}
                            className="flex items-center gap-2 px-6 py-2 border border-gray-300 rounded text-gray-600 font-bold text-sm">
                            <FiArrowLeft /> Previous
                        </button>
                        
                        <div className="flex gap-4">
                            <button onClick={() => {}} className="flex items-center gap-2 px-4 py-2 border border-gray-800 rounded text-gray-800 font-bold text-sm">
                                <FaEraser /> Clear
                            </button>
                            <button onClick={() => {}} className="flex items-center gap-2 px-4 py-2 bg-[#F97316] text-white rounded font-bold text-sm">
                                <FiFlag /> Mark for Review
                            </button>
                            <button onClick={handleNext} className="flex items-center gap-2 px-8 py-2 bg-[#4096F6] text-white rounded font-bold text-sm">
                                Save & Next <FiArrowRight />
                            </button>
                        </div>
                    </div> */}
                </div>

                {/* RIGHT SIDE: PALETTE */}
                <QuestionPalette 
                    questions={questions} 
                    currentQIndex={currentQIndex} 
                    handlePaletteClick={setCurrentQIndex}
                    tabs={tabs}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </main>
        </div>
    );
};

export default TestInterface;